import { Action } from 'redux';
import { Marketplace } from 'types/Marketplace';

export const MARKETPLACE_RESET_ACTION_TYPE = 'marketplace/reset';
export const MARKETPLACE_FETCH_ACTION_TYPE = 'marketplace/fetch_start';
export const MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE = 'marketplace/fetch_success';
export const MARKETPLACE_ERROR_ACTION_TYPE = 'marketplace/error';

interface MarketplaceResetAction extends Action<typeof MARKETPLACE_RESET_ACTION_TYPE> {}

interface MarketplaceFetchAction extends Action<typeof MARKETPLACE_FETCH_ACTION_TYPE> {}
interface MarketplaceFetchSuccessAction
    extends Action<typeof MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        marketplace: Marketplace;
    };
}

interface MarketplaceErrorAction extends Action<typeof MARKETPLACE_ERROR_ACTION_TYPE> {}

export type MarketplaceAction =
    | MarketplaceResetAction
    | MarketplaceFetchAction
    | MarketplaceFetchSuccessAction
    | MarketplaceErrorAction;
